import { render, staticRenderFns } from "./ProfileInsight.vue?vue&type=template&id=134d997e"
import script from "./ProfileInsight.vue?vue&type=script&lang=js"
export * from "./ProfileInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports